import { render, staticRenderFns } from "./BookingTrial.vue?vue&type=template&id=5d12a924&scoped=true&"
import script from "./BookingTrial.vue?vue&type=script&lang=js&"
export * from "./BookingTrial.vue?vue&type=script&lang=js&"
import style0 from "./BookingTrial.vue?vue&type=style&index=0&id=5d12a924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d12a924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d12a924')) {
      api.createRecord('5d12a924', component.options)
    } else {
      api.reload('5d12a924', component.options)
    }
    module.hot.accept("./BookingTrial.vue?vue&type=template&id=5d12a924&scoped=true&", function () {
      api.rerender('5d12a924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/BookingTrial.vue"
export default component.exports